import { parse as parseParams } from 'hub-http/helpers/params';
import useDetails from 'marketplace-ui-apps-core/details/hooks/useDetails';
import useDetailsPreview from 'marketplace-ui-apps-core/details/hooks/useDetailsPreview';
import ListingView from 'marketplace-ui-apps-core/details/records/ListingView';
import { useLocation, useParams, useRouteMatch } from 'react-router-dom';
import { useAppContext } from '../../context/AppContext';

// @ts-expect-error untyped dependency
import { useParsedPathParams } from './useParsedPathParams';
export function useListingView() {
  const {
    path
  } = useRouteMatch();
  const appContext = useAppContext();
  const {
    search
  } = useLocation();
  const params = useParams();
  const {
    published,
    language
  } = parseParams(search.slice(1));
  const isPreview = published === 'false' || path === '/_preview/:offeringId' || appContext === 'admin-preview';
  const {
    offeringId,
    slug
  } = useParsedPathParams(params);
  const {
    detailsData,
    detailsLoading,
    detailsError
  } = useDetails({
    appContext,
    slug,
    skip: isPreview
  });
  const {
    detailsPreviewData,
    detailsPreviewLoading,
    detailsPreviewError
  } = useDetailsPreview({
    appContext,
    offeringId,
    skip: !isPreview,
    language
  });
  return {
    listingView: new ListingView(isPreview ? Object.assign({}, detailsPreviewData === null || detailsPreviewData === void 0 ? void 0 : detailsPreviewData.appDetails) : Object.assign({}, detailsData === null || detailsData === void 0 ? void 0 : detailsData.appDetails)),
    loading: isPreview ? detailsPreviewLoading : detailsLoading,
    error: isPreview ? detailsPreviewError : detailsError
  };
}